import React from "react";
import { useLayout } from "../CustomHooks.js/LayoutContext";
import { isNullOrUndefined } from "../utils";
import { AddFlex } from "../reusableStyles";

function SecondaryTopComponent() {
  const {
    layoutState: { Component, props, children, showComponentOnMobile },
    clearLayoutComponent,
  } = useLayout();

  const getComponent = () => {
    if (isNullOrUndefined(Component)) return <></>;
    if (isNullOrUndefined(children)) {
      return (
        <AddFlex gap="10px">
          <Component {...props} />
        </AddFlex>
      );
    }
    return (
      <AddFlex gap="15px" alignItems="center">
        <Component {...props}>{children}</Component>
      </AddFlex>
    );
  };
  return <AddFlex padding="0 20px 20px 20px">{getComponent()}</AddFlex>;
}

export default SecondaryTopComponent;
